import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  contents: {
    paddingBottom: 40,
  },
  title: {
    paddingBottom: 12,
  },
}));

const ThyroidDecisionSmall = ({
  question1,
  question2,
  question3,
  question4,
  handleChange,
  forData,
  caseText,
}) => {
  const classes = useStyles();
  const questionReturn = (num) => {
    let question = question1;
    if (num === 1) {
      question = question1;
    } else if (num === 2) {
      question = question2;
    } else if (num === 3) {
      question = question3;
    } else if (num === 4) {
      question = question4;
    }
    return question;
  };
  return (
    <Grid
      container
      direction="column"
      justify="center"
      className={classes.root}
    >
      {forData.map((data, index) => (
        <Grid className={classes.contents} key={index}>
          <Typography variant="h4" className={classes.title}>
            {data.no}. {data.text}
          </Typography>
          <Grid container direction="column" justify="center">
            {data.list.map((d, i) => (
              <Grid container direction="row" alignItems="center" key={i}>
                <FormControlLabel
                  value={d}
                  control={
                    <Radio
                      checked={questionReturn(data.no) === d}
                      value={d}
                      onChange={(e) => handleChange(data.no, e)}
                      name="radio-buttons"
                      color="primary"
                      inputProps={{ "aria-label": d }}
                    />
                  }
                  label={caseText[i]}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default ThyroidDecisionSmall;
